import {
  PATIENT_NOT_VALIDATED,
  PATIENT_BLOCKED,
  PATIENT_VALIDATED,
} from 'services/constants';

export const userVerifyStatuses = {
  [PATIENT_NOT_VALIDATED]: 'not_verified_user',
  [PATIENT_BLOCKED]: 'blocked_user',
  [PATIENT_VALIDATED]: 'verified_user'
};
